<script>
	import SvgMask from './SvgMask.svelte'

	const numberOfRows = 28
	const numberOfColumns = 28

	const rows = new Array(numberOfRows)
	const cols = new Array(numberOfColumns)

	let items = []

	for (let col = 0; col < numberOfColumns; col++){
		for (let row = 0; row < numberOfRows; row++){
			items.push({
				col,
				row,
				place: `${col}/${row}`,
				show: Math.random() > 0.5, //col==5 && row==5 || col==5 && row==6 || col==6 && row==5 || col==6 && row==6 || col==4 && row==5 || col==3 && row==5 || col==3 && row==6,
				connections: [false, false, false, false]
			})
		}
	}

	// add connections
	items = items.map(item => {
		let connections = []
		connections.push(items.find(i => i.row === item.row -1 && i.col === item.col)?.show || false ) // top
		connections.push(items.find(i => i.row === item.row && i.col === item.col -1)?.show || false ) // left
		connections.push(items.find(i => i.row === item.row && i.col === item.col +1)?.show || false ) // right
		connections.push(items.find(i => i.row === item.row +1 && i.col === item.col)?.show || false ) // bottom
		return {
			...item,
			connections
		}
	})

	//add adjecent items
	items = items.map(item => {
		let adjecentItems = []
		adjecentItems.push(items.find(i => i.row === item.row -1 && i.col === item.col) || false ) // top
		adjecentItems.push(items.find(i => i.row === item.row && i.col === item.col -1) || false ) // left
		adjecentItems.push(items.find(i => i.row === item.row && i.col === item.col +1) || false ) // right
		adjecentItems.push(items.find(i => i.row === item.row +1 && i.col === item.col) || false ) // bottom
		adjecentItems = adjecentItems.filter(i => i && i.show)
		return {
			...item,
			adjecentItems
		}
	})

	console.log("items",items.filter(i => i.show))

	// recursive function to find all connected items
	const buildIsland = (startItem, islandItems=[]) => {
		// nothing if hidden item
		if (!startItem || !startItem.show || !startItem.adjecentItems) return islandItems
		// go through all connections
		for (let adjecentItem of startItem.adjecentItems){
			// get the full item that includes adjecentItems
			adjecentItem = items.find(i => i.row === adjecentItem.row && i.col === adjecentItem.col)
			// if adjecentItem exists
			if (adjecentItem && adjecentItem.show){
				// continue if already in island
				if (islandItems.find(i => i.place === adjecentItem.place)) continue
				// add to island
				islandItems.push(adjecentItem)
				// recurse
				islandItems = buildIsland(adjecentItem, islandItems)
			}
		}
		return islandItems
	}

	let islands = []

	// go through all items and build island if it isn't already part of an island
	for (let item of items){
		if (!item.show) continue
		if (islands.find(i => i.find(j => j.place === item.place))) continue
		islands.push(buildIsland(item))
	}

	islands = islands.filter(i => i.length > 0)

	console.log(islands[0])


</script>

<div class="disc">
	{#each islands as island}
		<div class="island">
			<SvgMask {rows} {cols} items={island}>
				<img src="https://placekitten.com/600/{ Math.round(Math.random() * 100 + 500) }" alt >
			</SvgMask>
		</div>
	{/each}
</div>


<style>
	.disc {
		width: 100vw;
		height: 100vw;
		position: relative;
	}

	.island {
		position: absolute;
		width: 100%;
		height: 100%;
		left:0;
		top:0;
	}
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	
</style>